<template>
  <div class="articles">
    <h1 class="articles__title">Добавление статьи</h1>
    <Textarea autoResize rows="1" cols="130" placeholder="Заголовок" />
    <Textarea autoResize rows="10" cols="130" placeholder="Описание" />
    <div class="articles__buttons">
      <BaseBtn blue plus text="Добавить медиа" />
      <BaseBtn blue plus text="Добавить файл" />
    </div>
    <div class="articles__archive archive">
      <h2 class="archive__title">Архив статей</h2>
      <div class="archive__content">
        <MaterialsArticleArchiveTable :data="dataSource" />
        <div class="archive__buttons">
          <BaseBtn blue text="Сохранить" />
          <BaseBtn blue text="Опубликовать" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import BaseBtn from '@/components/ui/BaseBtn.vue'
import MaterialsArticleArchiveTable from '@/components/blocks/MaterialsArticleArchiveTable.vue'

import Textarea from 'primevue/textarea'

export default {
  name: 'MaterisalsArticles',
  components: {
    BaseBtn,
    MaterialsArticleArchiveTable,
    Textarea
  },
  props: {
  },
  setup () {
    const store = useStore()

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsDataTable
    })

    return {
      dataSource
    }
  }
}
</script>

<style lang="scss" scoped>
  .articles {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &__title {
      font-size: 24px;
      margin-bottom: 24px;
    }

    &__buttons {
      display: flex;
      gap: 16px;
      margin-bottom: 80px;

      :deep(.blue-button) {
        display: flex;
        align-items: center;
        gap: 13px;
      }
    }

    &__archive,
    .archive {

      &__title {
        margin-bottom: 10px;
        font-size: 24px;
        text-align: left;
      }

      &__content {
        display: flex;
        align-items:flex-end;
        gap: 75px;
      }

      &__buttons {
        display: flex;
        gap: 24px;
      }
    }

    :deep(.p-inputtextarea) {
    margin-bottom: 8px;
    padding: 10px 16px;
    border-radius: 4px;
  }
}
</style>
